import React from 'react';
import { motion } from 'framer-motion';
import { FiRefreshCw } from 'react-icons/fi';

export const RefreshAnimation: React.FC = () => {
  return (
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ 
        duration: 2,
        repeat: Infinity,
        ease: "linear"
      }}
      className="inline-block"
    >
      <FiRefreshCw className="w-5 h-5 text-primary-light" />
    </motion.div>
  );
}; 